export default __webpack_public_path__ + "static/media/marauders-map-v5.0-03-05.614c6def.jpg";